// Modules
import { useCallback, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import axios from 'axios'

// Hooks
import useNotices from 'hooks/system/useNotices'

// Constants
import { VERIFICATION_URL } from 'constants/environment'

// Hook: Authentication > Verification
function useVerification () {
	// State
	const [error, setError] = useState(null)
	const [isProcessing, setIsProcessing] = useState(false)

	// Data
	const { addNotice } = useNotices()
	const navigate = useNavigate()

	// Functions (Memoized)
	const verify = useCallback (async payload => {
		setIsProcessing(true)
		try {
			const response = await axios({ data: payload, method: 'POST', url: VERIFICATION_URL })
			if (response?.status < 300) navigate('/login')
		} catch (error) {
			setError(error)
		}
		setIsProcessing(false)
	}, [navigate])

	useEffect(() => {
		if (!!error) addNotice({ code: 'client.verificationError', log: error, type: 'error' })
	}, [addNotice, error, navigate])

	// Response
	return { error, isProcessing, verify }
}

// Export
export default useVerification
